import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

// Design system: FTM tokens → vCIP additions → Cockpit classes → the scoped
// .droom consumer layer (warm-white ramp + --brand white-label hook + the core
// consumer primitives). Import ONCE at the app root, BEFORE the droom-specific
// flow chrome so the app-shell background wins the .droom cascade.
import '@vcip/design-system/styles.css';
import './styles/dataroom.css';

import { App } from './App';

const container = document.getElementById('root');
if (!container) throw new Error('Root element #root not found');

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
